__webpack_require__.p = "/learn/graphql/reason-react-apollo/";